import nunjucks from 'nunjucks';

export default () => {
    let env = nunjucks.configure(window.location.origin+'/');

    env.addFilter(
        'engsuffix',
        (str) => (1000 > Number(str))?
            str :
            Math.floor(100 * Number(str) / 1000) / 100 + 'k'
    );
    return env;
}
